"use strict";

exports.__esModule = true;
exports.LAYOUT = void 0;

/* Layout Constants */
var LAYOUT = {
  /* Actions */
  RESIZED: 'LAYOUT:RESIZED'
};
exports.LAYOUT = LAYOUT;